/*
 * File: CustomerNameSearch.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 10 Dec 2021 2:30:13 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Space } from 'antd';
import { FancyInput } from 'components/atoms/FancyInput';
import React, { ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { setFilterCustomerName } from 'redux/salesOrder/customerSelectionFiltersSlice';
import { useDebouncedCallback } from 'use-debounce';

export const CustomerNameSearch = (): JSX.Element => {
  const dispatch = useDispatch();

  /* ****************** Functions ****************** */
  // Handle delay of searching data
  const handleInputChange = useDebouncedCallback((ev: ChangeEvent<HTMLInputElement>) => {
    dispatch(setFilterCustomerName(ev.target.value));
  }, 500);

  /* ****************** Render ****************** */
  return (
    <Space direction="vertical" size="small">
      <FancyInput onChange={handleInputChange} placeholder="Customer Name" width={150} />
    </Space>
  );
};
